export default __webpack_public_path__ + "static/media/gesture@3x.60b09978.png";